module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "button-arrow-right.2daf429d.svg";